import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import en from '@/i18n/locales/en.json';
import nl from '@/i18n/locales/nl.json';
import LanguageFactory from '@/language/LanguageFactory';

Vue.use(VueI18n);

const languageFactory = new LanguageFactory();

function loadLocaleMessages(): LocaleMessages {
    return {
        en,
        nl,
    };
}

export default new VueI18n({
    locale: languageFactory.default().code,
    fallbackLocale: languageFactory.fallback().code,
    messages: loadLocaleMessages(),
});
